module.exports = __webpack_public_path__ + "img/img-ae31963a.57833944.png";